import React, { useState } from 'react';
import styled from "styled-components"
import { graphql, useStaticQuery, Link } from "gatsby"
import Img from "gatsby-image"
import { Row, Col } from 'react-grid-system';
import Product1 from "../../images/product/commerce2x-commerce-one.jpg"
import Product2 from "../../images/product/commerce2x-commerce-two.jpg"
import Product3 from "../../images/product/commerce2x-commerce-three.jpg"
import Product4 from "../../images/product/commerce2x-commerce-four.jpg"
import Product5 from "../../images/product/product-bigbarters-home.png"
import Product6 from "../../images/product/pattern-geometric.png"
import { Button } from 'carbon-components-react';

import ItemsCarousel from 'react-items-carousel';
import { Container} from "../global"
const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      file(sourceInstanceName: { eq: "product" }, name: { eq: "product-bigbarters-home" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)

  const handleSubmit = event => {
    event.preventDefault()
  }

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 40;

  return (
    <HeaderWrapper id="top">
      <Container>
        <Flex>
          <HeaderTextGroup>
            <Subtitle>Commerce cloud to grow your online business</Subtitle>
            <h1 style={{fontWeight:'700', fontSize:'60px', lineHeight:'72px', color:'#fff'}}>
            Online store, point of sale and marketplace. All in one commerce. 
            </h1>
            <p>
            Give your stores the tools to create the best shopping experiences. Build your online store, install our blazing fast point of sale and launch B2B & B2C marketplaces.
            </p>
            <HeaderForm onSubmit={handleSubmit}>
              <HeaderInput placeholder="Your email" />
              <HeaderButton style={{backgroundColor:'#D0F226', color:"#000"}}><a href="https://app.commerce2x.com" target="_blank" style={{textDecoration:'none', color:'#000', fontWeight:'700'}}>Start free trial</a></HeaderButton>
            </HeaderForm>
            <FormSubtitle>
              Try Commerce2x free for 30 days, no credit card required. By entering your <br/>email, you agree to Commerce2x terms and conditions.
              {/* <br/><br/> Already have a beta account?{" "}
              <FormSubtitleLink to="/">Sign in</FormSubtitleLink> */}
              
            </FormSubtitle>
           
          </HeaderTextGroup>
          <Text style={{marginLeft:'20px'}}>
            {/* <StyledImage fluid={data.file.childImageSharp.fluid} /> */}
            {/* <Button style={{backgroundColor:'#071435', borderRadius:'5px', float:'right'}}><h5>REQUEST A DEMO</h5></Button>  */}
            {/* <img src={Product5} style={{width:'95%', marginLeft:'20px'}}/> */}
             <Row style={{
            paddingTop: '0px'
          }}>
            
            <Col sm={12} md={6} lg={6}  >
            <img src={Product1} style={{width:'100%', borderRadius:'5px', margin:'10px'}}/>
            </Col>
            <Col  sm={12} md={6} lg={6}>
            <img src={Product2} style={{width:'100%',  height:'80%', borderRadius:'5px', margin:'10px'}}/>
            </Col>
            <Col  sm={12} md={6} lg={6}>
            <img src={Product3} style={{width:'100%', borderRadius:'5px', margin:'10px'}}/>
            </Col>
            <Col  sm={12} md={6} lg={6}>
            <img src={Product4} style={{width:'100%', borderRadius:'5px', margin:'10px'}}/>
            </Col>
            
          </Row>
          </Text>
          
        </Flex>
        
       
      </Container>
      {/* <div style={{backgroundImage: "url(" + Product6 + ")",
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat'}}>
Hello
      </div>
      <div style={{ padding: `0 ${chevronWidth}px` , marginBottom:'40px'}}>
      <ItemsCarousel
        requestToChangeActive={setActiveItemIndex}
        activeItemIndex={activeItemIndex}
        numberOfCards={6}
        gutter={30}
        leftChevron={<button>{'<'}</button>}
        rightChevron={<button>{'>'}</button>}
        chevronWidth={chevronWidth}
      >
        <div style={{ height: 300, background: '#EEE' }}></div>
        <div style={{ height: 300, background: '#EEE' }}></div>
        <div style={{ height: 300, background: '#EEE' }}></div>
        <div style={{ height: 300, background: '#EEE' }}></div>
        <div style={{ height: 300, background: '#EEE' }}></div>
        <div style={{ height: 300, background: '#EEE' }}></div>
    
      </ItemsCarousel>
    </div> */}
    </HeaderWrapper>
  )
}

export default Header

const HeaderWrapper = styled.header`
  background-color: #15141B;
  padding: 180px 0 120px 0;
  position: relative;
  // clip-path: polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 5vw));
  @media (max-width: ${props => props.theme.screen.lg}) {
  }
`
const Subtitle = styled.h5`
  font-size: 18px;
  color: ${props => props.theme.color.BLACK};
  letter-spacing: 0px;
  margin-bottom: 16px;
  color:#D0F225;
`

const HeaderTextGroup = styled.div`
  margin: 0;
  color:#fff;
  > div {
    width: 120%;
    margin-bottom: -4.5%;

    @media (max-width: ${props => props.theme.screen.lg}) {
      margin: 0 16px;
    }
  }

  h1 {
    margin: 0 0 24px;
    color: ${props => props.theme.color.primary};
  }

  h2 {
    margin-bottom: 24px;
    ${props => props.theme.font_size.regular}
  }

  p {
    margin-bottom: 48px;
    font-size:20px;
    line-height:26px;
  }
`

const Flex = styled.div`
  display: grid;
  justify-content: space-between;
  align-content: center;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    grid-gap: 64px;
  }
`

const HeaderForm = styled.form`
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;

  @media (max-width: ${props => props.theme.screen.sm}) {
    flex-direction: column;
  }
`

const FormSubtitle = styled.span`
  ${props => props.theme.font_size.xxxsmall}
`

const FormSubtitleLink = styled(Link)`
  color: ${props => props.theme.color.secondary};
  padding-bottom: 1px;
  margin-left: 8px;
  text-decoration: none;
  border-bottom: 1px solid ${props => props.theme.color.secondary};
`

const HeaderInput = styled.input`
  font-weight: 500;
  font-size: 16px;
  color: ${props => props.theme.color.primary};
  line-height: 42px;
  width: 100%;
  text-align: left;
  height: 60px;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => props.theme.color.secondary};
  border-image: initial;
  border-radius: 0px;
  padding: 8px 16px;
  margin-right:10px;
  outline: 0px;
  &:focus {
    box-shadow: inset ${props => props.theme.color.secondary} 0px 0px 0px 2px;
  }
  @media (max-width: ${props => props.theme.screen.md}) {
    margin-bottom: 8px;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    display: block;
    width: 100%;
  }
`

const HeaderButton = styled.button`
  font-weight: 700;
  font-size: 14px;
  color: white;
  letter-spacing: 1px;
  height: 60px;
  display: block;
  margin-left: 8px;
  cursor: pointer;
  white-space: nowrap;
  background: ${props => props.theme.color.black.regular};
  border-radius: 4px;
  padding: 0px 40px;
  border-width: 0px;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  outline: 0px;
  &:hover {
    box-shadow: rgba(110, 120, 152, 0.22) 0px 2px 10px 0px;
  }
  @media (max-width: ${props => props.theme.screen.md}) {
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    margin-left: 0;
  }
`
const Text = styled.div`
  justify-self: end;
  align-self: center;
  @media (max-width: ${props => props.theme.screen.md}) {
    justify-self: center;
  }
`

const StyledImage = styled(Img)`
  width: 500px;
  @media (max-width: ${props => props.theme.screen.md}) {
    width: 400px;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    width: 300px;
    display: none;
  }
`
